import { safeDefine } from "../../registration/safe-define.js";
import { SliderTrackElement } from "../../ui/slider/track.js";
//#region src/define/ui/slider-track.ts
safeDefine(SliderTrackElement);
//#endregion

//# sourceMappingURL=slider-track.js.map